<template>
    <li class="dropdown nav-tight nav-symbol">
        <a href="#" aria-expanded="false" role="button" data-toggle="dropdown" class="has-eicon" aria-label="user-profile">
            <img v-if="picture" class="myuser-image"
                 :alt="firstname + ' ' + lastname"
                 :src="'/storage/mediapool/profile_images/' + picture" v-cloak
            />
            <i class="fa-light fa-circle-user fa-lg" v-else v-cloak></i>
        </a>
        <ul id="myuser" class="dropdown-menu">
            <li>
                <div class="photo text-center">
                    <span>
                        <img v-if="picture" class="img-rounded img-md myuser-image"
                             :alt="firstname + ' ' + lastname"
                             :src="'/storage/mediapool/profile_images/' + picture"
                        />
                        <i class="fa-light fa-circle-user fa-4x" v-else></i>
                    </span>
                </div>
                <div class="name text-center">
                    <h3>{{ firstname }} {{ lastname }}</h3>
                    <p v-if="is_demo">(demo_user@easescreen.com)</p>
                    <p v-else-if="email !== null && email !== ''">({{ email }})</p>
                </div>
            </li>
            <li>
                <a href="#" @click="showModal('editProfileDialog')">
                    {{ t_edit }}
                </a>
            </li>
            <li v-if="change_project" class="nav-tight nav-symbol border-top">
                <a href="/administration/project-selection">
                    {{ t_change_project }}
                </a>
            </li>
            <li v-if="is_ext_user !== 1" class="nav-tight nav-symbol" :class="change_project ? '' : 'border-top'">
                <a href="/logout">
                    {{ t_logout }}
                </a>
            </li>
            <li v-else-if="ext_logout" class="nav-tight nav-symbol" :class="change_project ? '' : 'border-top'">
                <a :href="ext_auth_logout_link">
                    {{ t_logout }}
                </a>
            </li>
        </ul>
    </li>
</template>

<script>
    export default {
        props: [
            'picture',
            'firstname',
            'lastname',
            'email',
            'is_demo',
            'change_project',
            'is_ext_user',
            'ext_auth_logout_link'
        ],
        computed: {
            ext_logout: function () {
                return (this.is_ext_user === 1) && (this.ext_auth_logout_link !== 'sso-logout-not-set')
            }
        },
        data: function () {
            return {
                t_submit: Lang.langGet("Save"),
                t_edit: Lang.langGet("Edit my profile"),
                t_logout: Lang.langGet("Log out"),
                t_change_project: Lang.langGet("Change project"),
            }
        },
        methods: {
            'showModal': function(modal) {
                EaseEventBus.fire('showModal', modal);
            }
        }
    }
</script>

<style scoped>
    .myuser-image {
        width: 17px;
        height: 17px;
        border: 1px solid var(--text-color);
        border-radius: 10px;
        margin-top: -2px;
    }
</style>
